import { Alert, AlertDescription } from "@/components/ui/alert";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type PaymentConfirmDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    description: string;
    error: string | null;
    isPending: boolean;
    confirmLabel: string;
    pendingLabel: string;
    onConfirm: () => void;
};

export function PaymentConfirmDialog({
    open,
    onOpenChange,
    title,
    description,
    error,
    isPending,
    confirmLabel,
    pendingLabel,
    onConfirm,
}: PaymentConfirmDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent
                size="sm"
                className="z-[600]"
                overlayClassName="z-[600]"
            >
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                    <AlertDialogDescription>{description}</AlertDialogDescription>
                </AlertDialogHeader>
                {error ? (
                    <Alert variant="destructive">
                        <AlertDescription>{error}</AlertDescription>
                    </Alert>
                ) : null}
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isPending} type="button">
                        Cancel
                    </AlertDialogCancel>
                    <AlertDialogAction
                        type="button"
                        disabled={isPending}
                        onClick={() => {
                            onConfirm();
                        }}
                    >
                        {isPending ? pendingLabel : confirmLabel}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
